import { UnitConverter } from '@3d-scene/common/util/unit-converter';

export class RangeOnLineConnectionUtils {
  public static readonly STRETCH_LENGTH_IN_AWAY_UNITS: number = 2000;
  public static readonly STRETCH_LENGTH_IN_AWAY_UNITS_ON_BOTH_SIDES: number = 1000;

  public static getNativeTotalLengthInAwayUnits(length: number): number {
    return length - this.STRETCH_LENGTH_IN_AWAY_UNITS;
  }

  public static getOriginalTotalLengthInMM(length: number): number {
    return length - UnitConverter.fromTo('3d', 'mm', this.STRETCH_LENGTH_IN_AWAY_UNITS);
  }

  public static getOriginalPosOnRailInAwayUnits(pos: number): number {
    return pos + this.STRETCH_LENGTH_IN_AWAY_UNITS_ON_BOTH_SIDES;
  }

  public static getHalfStretchLengthInAwayUnits(): number {
    return this.STRETCH_LENGTH_IN_AWAY_UNITS_ON_BOTH_SIDES;
  }
}
